export default __webpack_public_path__ + "static/media/step2.a254185c.png";